import React from 'react';
import styles from './Container.module.scss';

const Container = ({center = false, className = '', children, fullWidth = false, id = undefined}) => {
    return (
        <div className={`${styles.container} ${className}`} id={id}>
            <div className={`${styles.inner} ${center && styles.center}`}>
                {children}
            </div>
        </div>
    )
}

export default Container;